import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import qs from "qs";
import { setInterval, clearInterval } from "worker-timers";

import Copyright from "../../components/Copyright";
import TrainsData from "./components/TrainsData";
import {
  getDateTime,
  getInitialSettings,
  getSearchParams,
  saveSettings,
  VALIDATION_SCHEMA,
} from "./helpers";
import SettingsModal from "./components/SettingsModal";
import { useFormik } from "formik";
import { API_URL } from "../../api";
import Link from "@mui/material/Link";

const Home = () => {
  const [trainsData, setTrainsData] = useState([]);
  const [intervalId, setIntervalId] = useState(null);
  const [speech, setSpeech] = useState(null);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const openSettingsModal = () => setIsSettingsModalOpen(true);
  const closeSettingsModal = () => {
    setIsSettingsModalOpen(false);
    formik.resetForm({ values: getInitialSettings() });
  };

  const formik = useFormik({
    initialValues: getInitialSettings(),
    validationSchema: VALIDATION_SCHEMA,
    onSubmit: (values) => {
      saveSettings(values);
      closeSettingsModal();
      checkSeatsAvailability();
    },
  });

  useEffect(() => {
    let speech = new SpeechSynthesisUtterance("Hello, my friend!");
    speech.lang = "ru";
    speech.rate = 5; // TODO add to settings
    setSpeech(speech);

    // window.speechSynthesis.onvoiceschanged = () => {
    //   console.log(window.speechSynthesis.getVoices());
    //   speech.text = "Hello, my friend!";
    //   speech.text = "Привет, мой друг!";
    //   setSpeech(speech);
    // };

    return () => {
      uncheck();
    };
  }, []);

  const getVoiceMessageText = (departureTime, seatsNumber, seatsCost) =>
    `На поезд с отправлением в ${departureTime} появилось ${seatsNumber} мест стоимостью ${seatsCost} рублей`;

  const getVoiceMessageTextUpdated = (departureTime, seats) => {
    const beginning = `На поезд с отправлением в ${departureTime} появилось `;
    const seatsMessages = seats.map(
      ({ seatsNumber, seatsCost }) =>
        `${seatsNumber} мест стоимостью ${seatsCost} рублей`
    );
    return beginning + seatsMessages.join(", ");
  };

  const getVoiceMessages = (trains) =>
    Object.keys(trains)
      .map((departureTime) =>
        getVoiceMessageTextUpdated(departureTime, trains[departureTime])
      )
      .join(". ");

  const isDataEqualToPrevData = (data, prevData) => {
    let isEqual = true;
    for (const departureTime in data) {
      if (departureTime !== "time") {
        if (
          JSON.stringify(
            data[departureTime].map(
              ({ seats_number: seatsNumber }) => seatsNumber
            )
          ) !==
          JSON.stringify(
            prevData[departureTime]?.map(
              ({ seats_number: seatsNumber }) => seatsNumber
            )
          )
        ) {
          isEqual = false;
        }
      }
    }

    return isEqual;
  };

  const playSound = (data, prevData) => {
    if (prevData && prevData.length !== 0) {
      // console.log(isDataEqualToPrevData(data, prevData));
      if (isDataEqualToPrevData(data, prevData)) return;
    }
    let isNeedAlarm = false;
    const messages = [];
    // console.log(data);
    const availableTrains = {};
    for (const train in data) {
      if (train !== "time") {
        for (const item of data[train]) {
          if (item.is_success) {
            isNeedAlarm = true;
            // messages.push(
            //   getVoiceMessageText(train, item.seats_number, item.seats_cost)
            // );
            if (!availableTrains[train]) {
              availableTrains[train] = [];
            }
            availableTrains[train].push({
              seatsNumber: item.seats_number,
              seatsCost: item.seats_cost,
            });
          }
        }
      }
    }
    if (isNeedAlarm) {
      // console.log(availableTrains);
      speech.text = getVoiceMessages(availableTrains);
      // console.log(speech.text);
      // speech.text = messages.toString();
      // speech.rate = 1;
      // speech.pitch = 1;
      // speech.volume = 1;
      // console.log(messages);
      // console.log(speech);
      window.speechSynthesis.speak(speech);
    }
  };

  // TODO Add "There is no such train

  const isDataSuccessful = (data) => {
    for (const train in data) {
      for (const item of data[train]) {
        if (item.is_success) {
          return true;
        }
      }
    }
    return false;
  };

  const searchTrains = async () => {
    try {
      const response = await axios.get(`${API_URL}/ticket_parser/`, {
        params: getSearchParams(formik.values),
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });

      if (isDataSuccessful(response.data)) {
        console.log(`Success, ${getDateTime(new Date())}: `, response.data);
      }

      const newTrainsData = {
        ...response.data,
        time: new Date(),
      };
      setTrainsData((prevState) => {
        playSound(newTrainsData, prevState[0]);
        return [newTrainsData, ...prevState.slice(0, 100)];
      });
    } catch (e) {
      console.log(e);
    }
  };

  const checkSeatsAvailability = () => {
    searchTrains();
    const intervalInMS = formik.values.checkInterval * 1000;
    setIntervalId(setInterval(searchTrains, intervalInMS));
  };

  const uncheck = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIntervalId(null);
  };

  const clearLogs = () => setTrainsData([]);

  const convertToRows = () => {
    let rows = [];
    for (const item of trainsData) {
      for (const key in item) {
        if (key !== "time") {
          rows = [
            ...rows,
            ...item[key].map((data) => ({
              ...data,
              departureTime: key,
              time: item.time,
            })),
          ];
        }
      }
    }
    return rows;
  };

  return (
    <Container
      maxWidth="md"
      sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Typography sx={{ mt: 2 }} variant="h4" component="h1" align="center">
        ПОМОГАТОР
      </Typography>
      <Link
        align="center"
        href="https://t.me/TicketPurchaseAssistantBot"
        target="_blank"
        rel="noopener"
      >
        Телеграм бот
      </Link>
      <Box sx={{ my: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          sx={{ mb: 4 }}
        >
          <Button
            variant="contained"
            onClick={openSettingsModal}
            disabled={!!intervalId}
            color="success"
          >
            Поехали
          </Button>
          <Button variant="outlined" color="error" onClick={uncheck}>
            Стоп
          </Button>
          <Button variant="outlined" color="error" onClick={clearLogs}>
            Очистить логи
          </Button>
        </Stack>
        <Box sx={{ maxHeight: "500px", overflow: "auto" }}>
          <TrainsData data={convertToRows()} />
        </Box>
        <Copyright />
      </Box>
      <SettingsModal
        isOpen={isSettingsModalOpen}
        closeModal={closeSettingsModal}
        formik={formik}
      />
    </Container>
  );
};

export default Home;
